import apiClient from './apiClient';

const roleService = {
  // Get all roles with pagination
  getAllRoles: async (params = {}) => {
    const response = await apiClient.get('/roles', { params });
    return response.data;
  },

  // Get permission matrix
  getPermissionMatrix: async () => {
    const response = await apiClient.get('/roles/matrix');
    return response.data;
  },

  // Create role
  createRole: async (roleData) => {
    const response = await apiClient.post('/roles', roleData);
    return response.data;
  },

  // Update role
  updateRole: async (roleId, roleData) => {
    const response = await apiClient.put(`/roles/${roleId}`, roleData);
    return response.data;
  },

  // Delete role
  deleteRole: async (roleId) => {
    const response = await apiClient.delete(`/roles/${roleId}`);
    return response.data;
  },

  // Get admin users
  getAdminUsers: async () => {
    const response = await apiClient.get('/roles/users');
    return response.data;
  },

  // Assign role to user
  assignRole: async (userId, roleId) => {
    const response = await apiClient.post(`/roles/assign/${userId}`, { roleId });
    return response.data;
  },

  // Bulk update role permissions
  bulkUpdatePermissions: async (updates) => {
    const response = await apiClient.post('/roles/bulk-permissions', { updates });
    return response.data;
  },

  // Get role statistics
  getRoleStats: async () => {
    const response = await apiClient.get('/roles/stats');
    return response.data;
  },

  getUsersWithRoles: async (params = {}) => {
    const response = await apiClient.get('/roles/users', { params });
    return response.data;
  }
};

export default roleService;